/*
 *
 * Settings reducer
 *
 */
import produce from 'immer';
import {
  FLUSH_STATE_SETTINGS,
  LOAD_SETTINGS,
  LOAD_SETTINGS_SUCCESS,
  LOAD_SETTINGS_ERROR,
} from './constants';

export const initialState = {
  loading: false,
  error: false,
  deleteSuccessful: false,
  settingsList: false,
  settingsData: false,
};

/* eslint-disable default-case, no-param-reassign */
const settingsReducer = (state = initialState, action) =>
  produce(state, draft => {
    switch (action.type) {
      case FLUSH_STATE_SETTINGS:
        return initialState;

      // LOAD
      case LOAD_SETTINGS:
        draft.loading = true;
        draft.error = false;
        break;

      case LOAD_SETTINGS_SUCCESS:
        draft.settingsList = action.settingsList;
        draft.loading = false;
        break;

      case LOAD_SETTINGS_ERROR:
        draft.error = action.error;
        draft.loading = false;
        break;

    }
  });

export default settingsReducer;
